module.exports = __webpack_public_path__ + "img/JL.756c9c4b.jpg";